<template lang="pug">
.page
    z-table(:columns="columns")
</template>

<script>
export default {
    name: 'FeeRate',
    data() {
        return {
            columns: [
                {
                    title: 'Product',
                    dataIndex: 'product',
                },
                {
                    title: 'Name',
                    dataIndex: 'name',
                },
                {
                    title: '是否百分比',
                    dataIndex: 'isRate',
                }
            ]
        }
    }
}
</script>

<style lang="less" scoped>
</style>